

























































































import BaseComponent from "@/asdcom/BaseComponent";
import { Component, Vue } from "vue-property-decorator";
import moment from "moment";
import {
  ICustomerUserSummary,
  ICurrentCustomerUserProfileDto,
  IRetrieveVcClaimsByUserInput,
  RetrieveVcClaimsByUserInput,
  IVcClaimSummaryLightDto,
  IApplicantsTasksDto
} from "@/asdcom/apiproxy/apiproxy.dto";
import { IHeader } from "@/store/models/staff/IHeader";
import OnlineUserComponent from "@/components/vcponlineok/staff-user/online-user-component.vue";
import bus from "@/components/vcponlineok/bus/bus.js";
import VueTheMask from "vue-the-mask";
Vue.use(VueTheMask);

interface ISearchInputModel {
  firstName?: string | null | undefined;
  lastName?: string | null | undefined;
  dOB?: moment.Moment | null | undefined;
  phoneNumber?: string | null | undefined;
  email?: string | null | undefined;
  userName?: string | null | undefined;
}

@Component({
  components: {
    OnlineUserComponent
  }
})
export default class OnlineUsers extends BaseComponent {
  isDetailsVisible?: boolean = false;
  viewModel: ISearchInputModel = {};
  dob: string = "";
  searchResult: ICustomerUserSummary[] = [];
  selectedProfile: ICurrentCustomerUserProfileDto | null = null;

  resultTableHeaders: IHeader[] = [
    { text: "First Name", value: "firstName" },
    { text: "Last Name", value: "lastName" },
    { text: "Date of Birth", value: "dob" },
    { text: "Phone Number", value: "phoneNumber" },
    { text: "Email", value: "email" },
    { text: "Username", value: "userName" }
  ];

  created() {
    this.getSearchResults();
  }

  mounted() {
    bus.$on("returnToListView", () => {
      this.isDetailsVisible = false;
    })
     bus.$on('refreshList', () => {
      this.getSearchResults();
    })
  }

  beforeDestroy() {
    bus.$off("returnToListView");
    bus.$off('refreshList');
  }

  isDateValid() {
    if (moment(this.dob).format() == "Invalid date") {
      const error = {
        field: 'Date of Birth',
        msg: "Please enter a valid date"
      };
      this.v_errors.add(error);
      return false;
    } else {
      this.v_errors.remove("Date of Birth");
      return true;
    }
  }

  async searchResultOnItemClick(item: any) {
    // get user profile.
    this.selectedProfile = await this.$appsvs.customerUser.getCustomerUserProfileByUserId(
      item.userId
    );
    // show details.
    this.isDetailsVisible = !!this.selectedProfile;
  }

  onSearchClick() {
    this.ValidateAll().then((isValid: boolean) => {
      if (isValid) {
        if (this.hasValue(this.dob)) {
          if (this.isDateValid()) {
            this.viewModel.dOB = moment(this.dob);
            this.getSearchResults();
          }
        } else {
          this.getSearchResults();
        }
      }
    })
  }

  async getSearchResults() {
    this.searchResult = await this.$appsvs.profile.searchPublicUser(
      this.viewModel.firstName,
      this.viewModel.lastName,
      this.viewModel.dOB,
      this.viewModel.phoneNumber,
      this.viewModel.email,
      this.viewModel.userName
    );
    if (this.searchResult == null) {
      this.searchResult = [];
    }
  }

  reloadSearchResults() {
    this.viewModel = {};
    this.dob = "";
    this.getSearchResults();
  }

  
}
